import {
    Navigate,
    Routes,
    Route,
    useParams,
    useNavigate, useLocation
} from 'react-router-dom';
// layouts
import MainLayout from './layouts/main';
import SimpleLayout from './layouts/simple';
import AuthLayout from './layouts/auth';
// pages
import Page404 from './pages/Page404';
import DashboardAppPage from './pages/DashboardAppPage';
// auth pages
import LoginPage from './pages/auth/LoginPage';
import LoginGoogleFinishPage from './pages/auth/LoginGoogleFinishPage';
import RegistrationPage from './pages/auth/RegistrationPage';
import ForgotPage from './pages/auth/ForgotPage';
// docs pages
import PrivacyPolicy from './pages/docs/PrivacyPolicy';
import TermsOfService from './pages/docs/TermsOfService';
import DocsLayout from './layouts/DocsLayout';
// grid pages
import UsersPage from './pages/grids/UsersPage';
import CoinsPage from './pages/grids/CoinsPage';
import TransactionsPage from './pages/grids/transactions/TransactionsPage';
import CurrenciesPage from './pages/grids/currencies/CurrenciesPage';
import CurrencyExchangePairsPage from './pages/grids/currencies/CurrencyExchangePairsPage';
import MerchantsPage from './pages/grids/merchants/MerchantsPage';
import PartnersPage from './pages/grids/partners/PartnersPage';
import PaymentGatewaysPage from './pages/grids/partners/PaymentGatewaysPage';
import WalletsPage from './pages/grids/WalletsPage';
import MerchantEmployeesPage from './pages/grids/merchants/MerchantEmployeesPage';
import MerchantsLocationsPage from './pages/grids/merchants/MerchantsLocationsPage';
import PartnerAccountsPage from './pages/grids/partners/PartnerAccountsPage';
import CoinCurrencyPairsPage from './pages/grids/currencies/CoinCurrencyPairsPage';
import CurrencyExchangeRatesPage from './pages/grids/currencies/CurrencyExchangeRatesPage';
import PartnerHasCoinsPage from './pages/grids/partners/PartnerHasCoinsPage';
import PartnerApiKeysPage from './pages/grids/partners/PartnerApiKeysPage';
import FeeTransactionsPage from './pages/grids/transactions/FeeTransactionsPage';
import MerchantCategories from './pages/grids/merchants/MerchantCategories';
import PayoutAccountsPage from './pages/grids/PayoutAccountsPage';
import MerchantInvitesPage from './pages/grids/merchants/MerchantInvitesPage';
import TransactionCouponsPage from './pages/grids/coupons/TransactionCouponsPage';
import InviteCodesPage from './pages/grids/coupons/InviteCodesPage';
import RolesPermissionsContainer from './pages/grids/permissionEditor/RolesPermissionsContainer';
import IncomingTransactionsPage from './pages/grids/transactions/IncomingTransactionsPage';
import OutgoingTransactionsPage from './pages/grids/transactions/OutgoingTransactionsPage';
import MarketingCampaignsPage from './pages/grids/marketing/campaigns/MarketingCampaignsPage';
import MarketingAudiencesPage from './pages/grids/marketing/MarketingAudiencesPage';
import MarketingCampaignsEditor from './pages/grids/marketing/campaigns/MarketingCampaignsEditor';
import SystemMessagesPage from './pages/grids/system-messages/SystemMessagesPage';

// ----------------------------------------------------------------------

function withRouteProps(Component, optionalProps = {}) {
    return (props) => {
        return (
            <Component
                {...props}
                {...optionalProps}
                params={useParams()}
                navigate={useNavigate()}
                location={useLocation()}
            />
        );
    };
}

export default function Router(props) {
    return (
        <Routes>
            <Route path="/app" Component={withRouteProps(MainLayout, props)}>
                <Route
                    path="/app"
                    index={true}
                    element={<Navigate to="/app/dashboard" />}
                />
                <Route
                    path={'/app/dashboard'}
                    Component={withRouteProps(DashboardAppPage, props)}
                />
                <Route path={'/app/users'} element={<UsersPage {...props} />} />
                <Route path={'/app/coins'} element={<CoinsPage {...props} />} />
                <Route
                    path={'/app/currencies'}
                    element={<CurrenciesPage {...props} />}
                />
                <Route
                    path={'/app/currency-exchange-pairs'}
                    element={<CurrencyExchangePairsPage {...props} />}
                />
                <Route
                    path={'/app/merchants'}
                    element={<MerchantsPage {...props} />}
                />
                <Route
                    path={'/app/merchant-employees'}
                    element={<MerchantEmployeesPage {...props} />}
                />
                <Route
                    path={'/app/merchants-locations'}
                    element={<MerchantsLocationsPage {...props} />}
                />
                <Route
                    path={'/app/partners'}
                    element={<PartnersPage {...props} />}
                />
                <Route
                    path={'/app/payment-gateways'}
                    element={<PaymentGatewaysPage {...props} />}
                />
                <Route
                    path={'/app/transactions'}
                    element={<TransactionsPage {...props} />}
                />
                <Route
                    path={'/app/role-permissions'}
                    element={<RolesPermissionsContainer {...props} />}
                />
                <Route
                    path={'/app/wallets'}
                    element={<WalletsPage {...props} />}
                />
                <Route
                    path={'/app/coin-currency-pairs'}
                    element={<CoinCurrencyPairsPage {...props} />}
                />
                <Route
                    path={'/app/currency-exchange-rates'}
                    element={<CurrencyExchangeRatesPage {...props} />}
                />
                <Route
                    path={'/app/partner-accounts'}
                    element={<PartnerAccountsPage {...props} />}
                />
                <Route
                    path={'partner-has-coins'}
                    element={<PartnerHasCoinsPage {...props} />}
                />
                <Route
                    path={'/app/partner-api-keys'}
                    element={<PartnerApiKeysPage {...props} />}
                />
                <Route
                    path={'/app/incoming-transactions'}
                    element={<IncomingTransactionsPage {...props} />}
                />
                <Route
                    path={'/app/outgoing-transactions'}
                    element={<OutgoingTransactionsPage {...props} />}
                />
                <Route
                    path={'/app/fee-transactions'}
                    element={<FeeTransactionsPage {...props} />}
                />
                <Route
                    path={'/app/merchant-categories'}
                    element={<MerchantCategories {...props} />}
                />
                <Route
                    path={'/app/payout-accounts'}
                    element={<PayoutAccountsPage {...props} />}
                />
                <Route
                    path={'/app/merchant-invites'}
                    element={<MerchantInvitesPage {...props} />}
                />
                <Route
                    path={'/app/transaction-coupons'}
                    element={<TransactionCouponsPage {...props} />}
                />
                <Route
                    path={'/app/invite-codes'}
                    element={<InviteCodesPage {...props} />}
                />
                <Route
                    path={'/app/marketing-campaigns'}
                    Component={withRouteProps(MarketingCampaignsPage, props)}
                />
                <Route
                    path={'/app/marketing-audiences'}
                    element={<MarketingAudiencesPage {...props} />}
                />
                <Route
                    path={'/app/marketing-campaigns/add'}
                    element={<MarketingCampaignsEditor {...props} />}
                />
                <Route
                    path={'/app/marketing-campaigns/update/:id'}
                    element={<MarketingCampaignsEditor {...props} />}
                />
                <Route
                    path={'/app/system-messages'}
                    element={<SystemMessagesPage {...props} />}
                />
            </Route>
            <Route path="/docs" element={<DocsLayout />}>
                <Route path="/docs/privacy" element={<PrivacyPolicy />} />
                <Route path="/docs/tos" element={<TermsOfService />} />
            </Route>
            <Route path="/auth" element={<AuthLayout />}>
                <Route
                    path="/auth"
                    index={true}
                    element={<Navigate to="/auth/login" />}
                />
                <Route path="/auth/login" element={<LoginPage />} />
                <Route
                    path="/auth/login-by-google"
                    element={<LoginGoogleFinishPage />}
                />
                <Route path="/auth/register" element={<RegistrationPage />} />
                <Route path="/auth/forgot" element={<ForgotPage />} />
            </Route>
            <Route path="/" element={<SimpleLayout />}>
                <Route
                    path="/"
                    index={true}
                    element={<Navigate to="/app/dashboard" />}
                />
                <Route path="/404" element={<Page404 />} />
                <Route path="*" element={<Navigate to="/404" />} />
            </Route>
            <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
    );
}
